/**
 * Generated by orval v6.22.1 🍺
 * Do not edit manually.
 * JUNO-API-SCHEMA
 * Auto-Generated JunoLive OpenApi3.0 Schema
 * OpenAPI spec version: 1.0.0
 */
import { CommentMediaTypeEnum } from './commentMediaTypeEnum';
import { BlankEnum } from './blankEnum';
import { NullEnum } from './nullEnum';

export type ThreadCommentMediaType = typeof ThreadCommentMediaType[keyof typeof ThreadCommentMediaType]  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ThreadCommentMediaType = {...CommentMediaTypeEnum,...BlankEnum,...NullEnum,} as const;
